module.exports = __webpack_public_path__ + "static/dmm-product-screenshot-5b0249b16f66b122afcec004bcee1730.png";